import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  error: {
    color: 'red',
  },
  hsLogo: {
    width: '150px',
    marginTop: 10,
  },
  blockLogo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
});
